import { getAPIUrl } from "../config";

const API_URL = getAPIUrl()

export const fetchUsers = async (venueId, getAccessTokenSilently) => {
  try {
    const token = await getAccessTokenSilently();
    const response = await fetch(`${API_URL}/api/v1/venues/${venueId}/users`, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    if (!response.ok) {
      throw new Error('Failed to fetch users');
    }
    return await response.json();
  } catch (error) {
    throw error;
  }
};

export const addUser = async (venueId, newUser, getAccessTokenSilently) => {
    try {
      const token = await getAccessTokenSilently();
      const response = await fetch(`${API_URL}/api/v1/venues/${venueId}/users`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          ...newUser,
          venueId: parseInt(newUser.venueId, 10),
          areaId: newUser.areaId ? parseInt(newUser.areaId, 10) : null,
          roleId: parseInt(newUser.roleId, 10)
        })
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        const errorMessage = errorData.error || `Failed to add user (${response.status})`;
        throw new Error(errorMessage);
      }

      return await response.json();
    } catch (error) {
      throw error;
    }
  };

export const updateUser = async (venueId, updatedUser, getAccessTokenSilently) => {
  try {
    const token = await getAccessTokenSilently();
    const response = await fetch(`${API_URL}/api/v1/venues/${venueId}/users/${updatedUser.id}`, {
      method: 'PUT',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        auth0Id: updatedUser.auth0Id,
        email: updatedUser.email,
        venueId: parseInt(updatedUser.venueId, 10),
        areaId: updatedUser.areaId,
        roleId: parseInt(updatedUser.roleId, 10)
      })
    });
    if (!response.ok) {
      throw new Error('Failed to update user');
    }
    return await response.json();
  } catch (error) {
    throw error;
  }
};

export const deleteUser = async (venueId, userId, getAccessTokenSilently) => {
  try {
    const token = await getAccessTokenSilently();
    const response = await fetch(`${API_URL}/api/v1/venues/${venueId}/users/${userId}`, {
      method: 'DELETE',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    if (!response.ok) {
      throw new Error('Failed to delete user');
    }
  } catch (error) {
    throw error;
  }
};


export const fetchUserContext = async (getAccessTokenSilently) => {
  try {
    const token = await getAccessTokenSilently();

    if (!token) {
      throw new Error('Failed to get token');
    }

    const response = await fetch(`${API_URL}/api/v1/me`, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });

    if (!response.ok) {
      throw new Error('Failed to fetch user context');
    }

    const userContext = await response.json();
    return userContext;
  } catch (error) {
    throw error;
  }
};

export const fetchRoles = async (getAccessTokenSilently) => {
  try {
    // Get the Auth0 access token
    const token = await getAccessTokenSilently();

    // Ensure the token is ready before making the request
    if (!token) {
      throw new Error('Failed to get token');
    }

    // Fetch roles from the Go backend API
    const response = await fetch(`${API_URL}/api/v1/roles`, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${token}`
      },
    });

    if (!response.ok) {
      throw new Error('Network response was not ok');
    }

    const data = await response.json();
    return data;
  } catch (error) {
    return [];
  }
};

export const sendPasswordResetEmail = async (userEmail, getAccessTokenSilently) => {
  try {
    const token = await getAccessTokenSilently();
    
    if (!token) {
      throw new Error('Failed to get token');
    }

    const response = await fetch(`${API_URL}/api/v1/users/send-password-reset`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        email: userEmail
      })
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      const errorMessage = errorData.error || `Failed to send password reset email (${response.status})`;
      throw new Error(errorMessage);
    }

    return await response.json();
  } catch (error) {
    throw error;
  }
};
